import { render, staticRenderFns } from "./overdue-invoices-client-dialog.vue?vue&type=template&id=3bd9185d"
import script from "./overdue-invoices-client-dialog.vue?vue&type=script&lang=js"
export * from "./overdue-invoices-client-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports